import { useSelector } from 'react-redux'

export const useCarouselsAutoplayState = () => {
  const preventCarouselAutoplay = useSelector(s => s.accessibility.preventCarouselAutoplay)
  const screenReaderState = useSelector(s => s.accessibility.screenReaderState)
  return screenReaderState ? true : preventCarouselAutoplay
}
